import React from "react";
import { FrontImg } from "./OverView.styled";
import { Text, Title } from "../styles/General.styled";

const OverView = () => {
  return (
    <>
      <FrontImg />
      <Title fs="3rem" m="2rem 0 0.5rem 0">
        Overview
      </Title>
      <Text fs="1.1rem" m="1rem 3rem">
        Many people pass away each year, and I want to use data to visualize the
        causes of these deaths and the amount of people that passed away due to
        each. In particular, I'm seeking the connections between the cause of
        death and culture.
      </Text>
      <Title fs="3rem" m="2rem 0 0.5rem 0">
        Data
      </Title>
      <Text m="-0.5rem 8rem 0 8rem">
        All Data displayed originates from: &nbsp;
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://data.cityofnewyork.us/Health/New-York-City-Leading-Causes-of-Death/jb7j-dtam">
          Data Source
        </a>
      </Text>
      <Title fs="3rem" m="2rem 0 0.5rem 0">
        Libraries
      </Title>
      <ul>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://seaborn.pydata.org/">
            Seaborn
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://pandas.pydata.org/">
            Pandas
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://matplotlib.org/">
            Matplotlib
          </a>
        </li>
      </ul>
      <Title fs="3rem" m="2rem 0 0.5rem 0">
        Techniques
      </Title>
      <Text fs="1.1rem" m="1rem 3rem">
        <ul>
          <li>Cleaned dataset, removing null and NaN values.</li>
          <li>
            Experiment with different plots, trying out different columns for x
            and y.
          </li>
          <li>
            Focus on extracting the data that corresponds with my overview.
          </li>
        </ul>
      </Text>
    </>
  );
};

export default OverView;
